export const FIRST_INTERVAL_DELAY = 500;
export const INTERVAL_DELAY = 1450;
